
import { IconProps } from "@/models/Icon";

export function AlertCircleIcon({ 
    size = 22, 
}: IconProps) {
    return(
        <svg width={size} height={size} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11Z" fill="#FFC0C6"/>
        <path d="M10.9998 5.16667C7.77984 5.16667 5.1665 7.78 5.1665 11C5.1665 14.22 7.77984 16.8333 10.9998 16.8333C14.2198 16.8333 16.8332 14.22 16.8332 11C16.8332 7.78 14.2198 5.16667 10.9998 5.16667ZM11.5832 13.9167H10.4165V12.75H11.5832V13.9167ZM11.5832 11.5833H10.4165V8.08334H11.5832V11.5833Z" fill="#C62828"/>
        </svg>
    )
}